// custom-elements/LanguageSelector.tsx
import React from 'react';
import { Select } from 'antd';
import languages from '../../assets/data/languagesOptions.json'; // Adjust path to where your JSON is located

const { Option } = Select;

interface LanguageSelectorProps {
  currentLanguage: string;
  onLanguageChange: (value: string) => void; // Add the onLanguageChange callback
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ currentLanguage, onLanguageChange }) => (
  <Select id='speciesSelectLanguageId' value={currentLanguage} style={{ width: 120 }} onChange={onLanguageChange}>
    {languages.map((language) => (
      <Option key={language.code} value={language.code}>
        {language.label}
      </Option>
    ))}
  </Select>
);

export default LanguageSelector;
